import axios from 'axios';
import {req, exportExcel} from './axiosFun';

/**
 * 首页
 **/
// 首页
export const indexData = (params) => {
  return req("post", "/api/auth/index/data",params)
};
// 入驻公告
export const indexNotice = (params) => {
  return req("post", "/api/auth/index/notice",params)
};
// 同意入驻公告
export const agreeNotice = (id) => {
  return req("post", "/api/auth/agree/notice?id=" + id)
};

/**
 * 商品管理
 **/
// 是否展示 松佰牙科ERP数据导入按钮
export const erpImportBtn = (params) => {
  return req("post", "/api/auth/product/show/erp/import/btn",params)
};
// 子公司商品同步
export const syncProduct = (params) => {
  return req("post", "/api/auth/sync/product",params)
};
// 子公司商品列表
export const syncProductList = (params) => {
  return req("post", "/api/auth/sync/product/list",params)
};
// 商品管理-商品列表
export const productList = (params) => {
  return req("post", "/api/auth/product/list",params)
};
// 商品管理-上下架
export const productPutaway = (params) => {
  return req("post", "/api/auth/product/putaway", params)
};
// 商品管理-导出
export const productExcel = (params) => {
  return exportExcel("post", "/api/auth/product/export",params)
};
// 商品管理-修改单价
export const productRevisePrice = (params) => {
  return req("get", "/api/auth/product/modifySalePrice?sellerProductId=" + params.sellerProductId + '&price=' + params.price)
};
// 商品管理-修改商品上架数
export const productReviseNum = (params) => {
  return req("get", "/api/auth/product/modifyPutawayNum?sellerProductId=" + params.sellerProductId + '&num=' + params.num)
};
// 商品管理-商品分类
export const productTree = () => {
  return req("get", "/api/auth/product/tree")
};
// 商品管理-商品分类下品牌
export const productBrand = (sortId) => {
  return req("get", "/api/auth/product/brand?sortId=" + sortId)
};
// 商品管理-商品分类下的动态属性
export const attrValues = (sortId) => {
  return req("get", "/api/auth/product/attr/values?sortId=" + sortId)
};
// 商品管理-添加商品
export const addProduct = (params) => {
  return req("post", "/api/auth/add/product", params)
};
// 商品管理-设置标签
export const setLabel = (params) => {
  return req("post", "/api/auth/product/set/label", params)
};
// 商品管理-删除标签
export const deleteLabel = (params) => {
  return req("post", "/api/auth/product/delete/label", params)
};
// 商品管理-修改商品
export const editProduct = (params) => {
  return req("post", "/api/auth/update/product", params)
};
// 商品管理-商品基础信息列表
export const productInfoList = (params) => {
  return req("post", "/api/auth/product/base/info/list",params)
};
// 商品管理-查看详情
export const productDetail = (productId) => {
  return req("get", "/api/auth/product/detail?productId=" + productId)
};
// 商品管理-删除商品
export const deleteProduct = (productId) => {
  return req("get", "/api/auth/delete/product?productId=" + productId)
};
// 商品管理-修改分类
export const updateProductSort = (params) => {
  return req("post", "/api/auth/update/product/sort",params)
};
// 商品管理-商品提交审核
export const submitAudit = (productId) => {
  return req("get", "/api/auth/product/submit/audit?productId=" + productId)
};
// 商品管理-店铺分类列表接口
export const sortList = (params) => {
  return req("post", "/api/auth/shop/sort/list",params)
};
// 商品管理-添加店铺分类
export const addSort = (params) => {
  return req("post", "/api/auth/shop/sort/add", params)
};
// 商品管理-修改店铺分类
export const updateSort = (params) => {
  return req("post", "/api/auth/shop/sort/update", params)
};
// 商品管理-删除店铺分类
export const deleteSort = (id) => {
  return req("get", "/api/auth/shop/sort/delete?id=" + id)
};
// 商品管理-店铺分类-已选列表
export const selectedList = (params) => {
  return req("post", "/api/auth/shop/sort/selected/list",params)
};
// 商品管理-店铺分类-待选列表
export const selectList = (params) => {
  return req("post", "/api/auth/shop/sort/select/list",params)
};
// 商品管理-店铺分类-保存商品
export const saveProductSort = (params) => {
  return req("post", "/api/auth/shop/sort/save/product",params)
};
// 复制商品
export const copyProduct = (params) => {
  return req("post", "/api/auth/copy/product",params)
};
// 商品管理-查看商品大图
export const productBigPic = (productId) => {
  return req("get", "/api/auth/product/big/pic?productId=" + productId)
};
// 商品管理-判断销售商类型
export const getSellerInfo = () => {
  return req("post", "/api/auth/seller/info")
};
// 总部erp计量单位列表
export const unitList = (productId) => {
  return req("post", "/api/auth/group/erp/unit/list?productId=" + productId)
};

// 基础信息模板下载
export const baseinfoExport = (params) => {
  return exportExcel("post", "/api/auth/product/template/baseinfo/export", params)
};
// 批量导入基础信息日志记录
export const logsList = (params) => {
  return req("post", "/api/auth/product/template/baseinfo/import/logs/list", params)
};
// 批量导入基础信息日志详细记录
export const logsDetailList = (params) => {
  return req("post", "/api/auth/product/template/baseinfo/import/logs/detail/list", params)
};
// 批量导入基础信息日志明细汇总
export const logsDetailListGroup = (params) => {
  return req("post", "/api/auth/product/template/baseinfo/import/logs/detail/list/group", params)
};
// 批量导入基本信息
export const batchImport = (params) => {
  return req("post", "/api/auth/product/template/baseinfo/batch/import", params)
};

// 商品上架模板下载
export const putawayExport = (params) => {
  return exportExcel("post", "/api/auth/product/template/putaway/export", params)
};
// 批量导入上架信息日志记录
export const importLogsList = (params) => {
  return req("post", "/api/auth/product/template/putaway/import/logs/list", params)
};
// 批量导入上架信息日志明细
export const importLogsDetailList = (params) => {
  return req("post", "/api/auth/product/template/putaway/import/logs/detail/list", params)
};
// 批量导入上架信息
export const putawayBatchImport = (params) => {
  return req("post", "/api/auth/product/template/putaway/batch/import", params)
};

/*
 *商品管理-商品动态属性
 */
// 商品动态属性-列表
export const attrList = (params) => {
  return req("post", "/api/auth/attr/list",params)
};
// 商品动态属性-新增
export const attrAdd = (params) => {
  return req("post", "/api/auth/attr/add",params)
};
// 商品动态属性-修改
export const attrUpdate = (params) => {
  return req("post", "/api/auth/attr/update",params)
};
// 商品动态属性-详情
export const attrDetail = (id) => {
  return req("get", "/api/auth/attr/detail?id=" + id)
};
// 商品动态属性-删除
export const attrDelete = (id) => {
  return req("get", "/api/auth/attr/delete?id=" + id)
};

// 销售标签-列表
export const labelList = (params) => {
  return req("post", "/api/auth/product/sales/label/list",params)
};
// 销售标签-新增
export const labelAdd = (params) => {
  return req("post", "/api/auth/product/sales/label/add",params)
};
// 销售标签-修改
export const labelUpdate = (params) => {
  return req("post", "/api/auth/product/sales/label/update",params)
};
// 销售标签-删除
export const labelDelete = (id) => {
  return req("get", "/api/auth/product/sales/label/delete?id=" + id)
};
// 销售标签-详情
export const labelDetail = (id) => {
  return req("get", "/api/auth/product/sales/label/detail?id=" + id)
};
// 销售标签-设置有效
export const labelEnabled = (id) => {
  return req("get", "/api/auth/product/sales/label/enabled?id=" + id)
};
// 销售标签-设置无效
export const labelDisable = (id) => {
  return req("get", "/api/auth/product/sales/label/disable?id=" + id)
};
// 商品关联-列表
export const relationList = (params) => {
  return req("post", "/api/auth/product/relation/list",params)
};
// 关联商品
export const relationAdd = (params) => {
  return req("post", "/api/auth/product/relation/add",params)
};
// 商品关联-已选列表
export const relationSelectedList = (params) => {
  return req("post", "/api/auth/product/relation/selected/list",params)
};
// 商品关联-待选列表
export const relationSelectList = (params) => {
  return req("post", "/api/auth/product/relation/select/list",params)
};
// 商品关联-关联详情列表
export const relationRelationList = (params) => {
  return req("post", "/api/auth/product/relation/relation/list",params)
};
// 商品管理-商品导入列表
export const erpProductList = (params) => {
  return req("post", "/api/auth/group/erp/product/list",params)
};
// 商品管理-商品导入
export const erpImportProduct = (params) => {
  return req("post", "/api/auth/group/erp/import/product",params)
};
// 商品关联-设置商品查询名称
export const searchDisplayName = (params) => {
  return req("post", "/api/auth/product/relation/update/search/display/name",params)
};

/*
 * 页面推荐管理
 */
// 店铺推荐位置-列表
export const shopRecommendList = (params) => {
  return req("post", "/api/auth/shop/recommend/list",params)
};
// 店铺推荐位置-新增
export const shopRecommendAdd = (params) => {
  return req("post", "/api/auth/shop/recommend/add",params)
};
// 店铺推荐位置-修改
export const shopRecommendUpdate = (params) => {
  return req("post", "/api/auth/shop/recommend/update",params)
};
// 订单满赠详情-设置有效
export const shopRecommendEnabled = (id) => {
  return req("get", "/api/auth/shop/recommend/enabled?id=" + id)
};
// 订单满赠详情-设置无效
export const shopRecommendDisabled = (id) => {
  return req("get", "/api/auth/shop/recommend/disabled?id=" + id)
};
// 店铺推荐位置-详情
export const shopRecommendDetail = (id) => {
  return req("get", "/api/auth/shop/recommend/detail?id=" + id)
};
// 店铺推荐位置-删除
export const shopRecommendDelete = (id) => {
  return req("get", "/api/auth/shop/recommend/delete?id=" + id)
};

/**
 * 店铺管理
 */
// 详情
export const shopInfo = (params) => {
  return req("post", "/api/auth/shop/info",params)
};
// 新增
export const shopAdd = (params) => {
  return req("post", "/api/auth/shop/add",params)
};
// 修改
export const shopUpdate = (params) => {
  return req("post", "/api/auth/shop/update",params)
};
// 店铺banner图-详情
export const shopBannerInfo = (params) => {
  return req("post", "/api/auth/shop/banner/info",params)
};
// 店铺banner图-新增
export const shopBannerAdd = (params) => {
  return req("post", "/api/auth/shop/banner/add",params)
};
// 店铺banner图-修改
export const shopBannerUpdate = (params) => {
  return req("post", "/api/auth/shop/banner/update",params)
};
export const shopImage = (params) => {
  return req("post", "/api/auth/upload/tmp/image",params)
};
// 电子面单物流公司列表
export const eorderDeliveryList = (params) => {
  return req("post", "/api/auth/eorder/delivery/list",params)
};
// 物流公司信息-列表
export const companyList = (params) => {
  return req("post", "/api/auth/delivery/company/list",params)
};
// 物流公司信息-新增
export const companyAdd = (params) => {
  return req("post", "/api/auth/delivery/company/add",params)
};
// 物流公司信息-修改
export const companyUpdate = (params) => {
  return req("post", "/api/auth/delivery/company/update",params)
};
// 长沙仓物流公司列表-新增时，选择对应物流公司
export const csdeliveryList = (params) => {
  return req("post", "/api/auth/cs/delivery/list",params)
};
// 物流公司信息-设置有效
export const companyEnable = (id) => {
  return req("get", "/api/auth/delivery/company/enable?id=" + id)
};
// 物流公司信息-设置无效
export const companyDisable = (id) => {
  return req("get", "/api/auth/delivery/company/disable?id=" + id)
};
// 物流公司信息-详情
export const companyDetail = (id) => {
  return req("get", "/api/auth/delivery/company/detail?id=" + id)
};
// 打印机-列表
export const printerList = (params) => {
  return req("post", "/api/auth/user/bind/printer/list",params)
};
// 打印机-新增
export const printerAdd = (params) => {
  return req("post", "/api/auth/user/bind/printer/add",params)
};
// 打印机-修改
export const printerUpdate = (params) => {
  return req("post", "/api/auth/user/bind/printer/update",params)
};
// 打印机-详情
export const printerDetail = (params) => {
  return req("get", "/api/auth/user/bind/printer/detail",params)
};
//快递运费配置-列表
export const deliveryConfigList = (params) => {
  return req("post", "/api/auth/seller/delivery/config/list",params)
};
// 快递运费配置-新增
export const deliveryConfigAdd = (params) => {
  return req("post", "/api/auth/seller/delivery/config/add",params)
};
// 快递运费配置-修改
export const deliveryConfigUpdate = (params) => {
  return req("post", "/api/auth/seller/delivery/config/update",params)
};
// 快递运费配置-详情
export const deliveryConfigDetail = (id) => {
  return req("get", "/api/auth/seller/delivery/config/detail?id=" + id)
};
// 快递运费配置-有效状态修改
export const deliveryConfigUpdateStatus = (params) => {
  return req("post", "/api/auth/seller/delivery/config/updateStatus",params)
};

// 客户账期管理-列表
export const accountList = (params) => {
  return req("post", "/api/auth/cust/account/list",params)
};
// 客户账期管理-新增
export const accountAdd = (params) => {
  return req("post", "/api/auth/cust/account/add",params)
};
// 客户账期管理-修改
export const accountModify = (params) => {
  return req("post", "/api/auth/cust/account/modify",params)
};
// 客户账期管理-查询客户单位下拉框
export const accountCompanyList = (params) => {
  return req("post", "/api/auth/cust/account/company/list",params)
};

/**
 * 订单管理
 **/
// 结算订单
export const settleOrder = (orderId, isSupplier) => {
  return req("post", "/api/auth/settle/order?orderId=" + orderId + '&isSupplier=' + isSupplier)
};
// 订单管理-订单列表
export const orderList = (params) => {
  return req("post", "/api/auth/order/list",params)
};
// 订单管理-导出
export const orderExcel = (params) => {
  return exportExcel("post", "/api/auth/order/export?startDate",params)
};
// 订单管理-订单详情
export const orderDetail = (orderId) => {
  return req("get", "/api/auth/order/detail?orderId=" + orderId)
};
// 订单管理-代发详情
export const agentDetail = (orderId) => {
  return req("get", "/api/auth/order/agent/detail?orderId=" + orderId)
};
// 订单管理-订单发货记录
export const sendRecord = (sendId) => {
  return req("get", "/api/auth/order/sendRecord?sendId=" + sendId)
};
// 订单管理-添加发票
export const addInvoice = (orderId,custInvoiceId,params) => {
  return req("post", "/api/auth/order/addInvoice?orderId=" + orderId+'&custInvoiceId='+custInvoiceId,params)
};
// 订单管理-商品发货清单
export const orderSend = (sendId) => {
  return req("get", "/api/auth/order/send?sendId=" + sendId)
};
// 未发货出库单打印-导出
export const outListExport = (params) => {
  return exportExcel("post", "/api/auth/order/no/out/list/export",params)
};
// 未发货出库单预览
export const outListPreview = (params) => {
  return req("post", "/api/auth/order/no/out/list/preview",params)
};
// 未发货出库单预览
export const outListAliyunPrint = (params) => {
  return req("post", "/api/auth/order/no/out/list/aliyun/print",params)
};

// 订单管理-商品发货
export const addSend = (params) => {
  return req("post", "/api/auth/order/addSend",params)
};
// 订单管理-上架商品详情
export const sellerProductDetail = (sellerProductId) => {
  return req("get", "/api/auth/product/sellerProduct?sellerProductId=" + sellerProductId)
};
// 订单管理-订单修改物流信息
export const updateDelivery = (params) => {
  return req("post", "/api/auth/order/update/delivery",params)
};
// 订单管理-商品清单导出
export const productListExport = (orderId) => {
  return exportExcel("post", "/api/auth/order/product/list/export?orderId=" + orderId)
};
// 订单管理-修改订单为已支付
export const confirmPayed = (params) => {
  return req("post", "/api/auth/confirm/payed",params)
};
// 订单管理-支付图片凭证
export const payReceiptDetail = (orderId) => {
  return req("get", "/api/auth/order/pay/receipt/detail?orderId=" + orderId)
};
// 订单管理-修改图片凭证
export const payReceiptUpdate = (params) => {
  return req("post", "/api/auth/order/pay/receipt/update",params)
};
// 订单管理-退款凭证详情
export const voucherDetail = (orderId) => {
  return req("get", "/api/auth/refund/voucher/detail?orderId=" + orderId)
};
// 上传-修改退款凭证
export const refundVoucher = (params) => {
  return req("get", "/api/auth/modify/refund/voucher?orderId=" + params.orderId + '&imgUrl=' + params.imgUrl)
};
// 订单管理-取消订单
export const cancelOrder = (orderId) => {
  return req("post", "/api/auth/cancel/order?orderId=" + orderId)
};
// 订单商品-列表
export const itemList = (params) => {
  return req("post", "/api/auth/order/item/list",params)
};
// 订单商品-新增
export const itemAdd = (params) => {
  return req("post", "/api/auth/order/item/add",params)
};
// 订单商品-修改
export const itemUpdate = (params) => {
  return req("post", "/api/auth/order/item/update",params)
};
// 订单商品-库存校验
export const itemStockCheck = (product_id, num) => {
  return req("get", "/api/auth/order/item/stock/check?product_id=" + product_id + '&num='+num)
};
// 订单商品-详情
export const itemDetail = (id) => {
  return req("get", "/api/auth/order/item/detail?id=" + id)
};
// 订单商品-删除
export const itemDelete = (id) => {
  return req("get", "/api/auth/order/item/delete?id=" + id)
};
/**
 * 供货管理
 */
// 供货关系类型管理-详情
export const agentInfo = (params) => {
  return req("post", "/api/auth/agent/type/detail",params)
};
// 供货关系类型管理-修改
export const agentUpdate = (params) => {
  return req("post", "/api/auth/agent/type/update",params)
};
// 供货关系管理-我供货的-列表
export const supplierPurchaserList = (params) => {
  return req("post", "/api/auth/agent/relation/supplier/purchaser/list", params)
};
// 供货关系管理-我供货的-解除供货关系
export const supplierTerminate = (params) => {
  return req("post", "/api/auth/agent/relation/supplier/terminate", params)
};
// 供货关系管理-我供货的-新增-商家名称
export const supplierPurchaserName = (params) => {
  return req("post", "/api/auth/agent/relation/supplier/purchaser/name/list", params)
};
// 供货关系管理-我供货的-导出
export const supplierPurchaserExport = (params) => {
  return exportExcel("post", "/api/auth/agent/relation/supplier/export/purchaser", params)
};
// 供货关系管理-我供货的-新增-确认
export const supplierPurchaserAdd = (params) => {
  return req("post", "/api/auth/agent/relation/supplier/add/purchaser", params)
};
// 供货关系管理-给我供货-列表
export const purchaserSupplierList = (params) => {
  return req("post", "/api/auth/agent/relation/purchaser/supplier/list", params)
};
// 供货关系管理-给我供货-导出
export const purchaserSupplierExport = (params) => {
  return exportExcel("post", "/api/auth/agent/relation/purchaser/export/supplier", params)
};
// 供货关系管理-给我供货-审核
export const purchaserSupplierAudit = (params) => {
  return req("post", "/api/auth/agent/relation/purchaser/add/supplier/audit", params)
};
// 供货商品管理-修改
export const agentProductUpdate = (params) => {
  return req("post", "/api/auth/agent/product/update/price",params)
};
// 供货商品管理-我供货的-列表
export const supplierProductList = (params) => {
  return req("post", "/api/auth/agent/product/supply/list", params)
};
// 供货商品管理-查询我供货的供应商下拉框
export const supplierProductAll = (params) => {
  return req("get", "/api/auth/agent/product/supplier/purchaser/all", params)
};
// 供货商品管理-我供货的-新增-查询商家已供货商品
export const putawayedProduct = (params) => {
  return req("post", "/api/auth/agent/product/query/putawayed/product", params)
};
// 供货商品管理-我供货的-新增-查询供应商已供货商品
export const selfPutawayedProduct = (params) => {
  return req("post", "/api/auth/agent/product/query/self/putawayed/product", params)
};
// 供货商品管理-给我供货-列表
export const productPurchaseList = (params) => {
  return req("post", "/api/auth/agent/product/purchase/list", params)
};
// 供货商品管理-查看价格历史
export const productPriceLog = (params) => {
  return req("post", "/api/auth/agent/product/price/log", params)
};
// 供货商品管理-我供货的-导出
export const productSupplyExport = (params) => {
  return exportExcel("post", "/api/auth/agent/product/export/supply", params)
};
// 供货商品管理-给我供货-导出
export const productPurchaseExport = (params) => {
  return exportExcel("post", "/api/auth/agent/product/export/purchase", params)
};
// 供货商品管理-我供货的-修改状态
export const productUpdateStatus = (params) => {
  return req("post", "/api/auth/agent/product/update/status", params)
};
// 供货商品管理-我供货的-新增
export const agentProductAdd = (params) => {
  return req("post", "/api/auth/agent/product/add", params)
};
// 我供货的-修改产品证件
export const updateLicenses = (params) => {
  return req("post", "/api/auth/agent/product/update/licenses", params)
};
//商品管理-商品销售列表-上架修改-代发类型获取供应商
export const productSupplierList = (params) => {
  return req("post", "/api/auth/product/supplier/list", params)
};
// 我供货的-列表查询
export const purchaseProductList = (params) => {
  return req("post", "/api/auth/agent/purchase/product/list",params)
};
// 我供货的-设置供货商品-已选列表
export const productSelectedList = (params) => {
  return req("post", "/api/auth/agent/purchase/product/selected/list",params)
};
// 我供货的-设置供货商品-待选列表
export const productSelectList = (params) => {
  return req("post", "/api/auth/agent/purchase/product/select/list",params)
};
// 我供货的-设置供货商品-新增
export const productAdd = (params) => {
  return req("post", "/api/auth/agent/purchase/product/add",params)
};
// 我供货的-设置供货商品-删除
export const productDelete = (seller_purchaser_product_id) => {
  return req("get", "/api/auth/agent/purchase/product/delete?seller_purchaser_product_id=" + seller_purchaser_product_id)
};
// // 我供货的发票-列表
// export const toSupplyList = (params) => {
//   return req("post", "/api/auth/agent/invoice/apply/toSupply/list",params)
// };
// // 给我供货发票-列表
// export const toMeList = (params) => {
//   return req("post", "/api/auth/agent/invoice/apply/toMe/list",params)
// };
// 发票申请
export const invoiceApply = (params) => {
  return req("post", "/api/auth/agent/invoice/apply",params)
};
// 供货商开票信息（抬头）
export const supplyTitle = (params) => {
  return req("get", "/api/auth/agent/invoice/supply/title",params)
};
// 我供货的-售后
export const toSellerList = (params) => {
  return req("post", "/api/auth/agent/after/toSeller/list",params)
};
// 我供货售后-结算
export const toMeSettle = (params) => {
  return req("post", "/api/auth/agent/after/toMe/settle",params)
};
// 给我供货-售后
export const toMeList = (params) => {
  return req("post", "/api/auth/agent/after/toMe/list",params)
};

/**
 * 售后服务
 **/
// 售后服务-列表
export const aftersaleList = (params) => {
  return req("post", "/api/auth/after/service/list", params)
};
// 售后服务-仓库列表
// export const stockList = (params) => {
//   return req("post", "/api/auth/after/service/stock/list", params)
// };
// 售后服务-审核详情
export const checkDetail = (id) => {
  return req("post", "/api/auth/after/service/check/detail?id=" + id)
};
// 售后服务-审核
export const serviceCheck = (params) => {
  return req("post", "/api/auth/after/service/check", params)
};
// 售后服务-确认收货
export const confirmReceipt = (id) => {
  return req("get", "/api/auth/after/service/confirm/receipt?id=" + id)
};
// 售后服务-确认退款
export const confirmRefund = (id,imgUrl) => {
  return req("get", "/api/auth/after/service/confirm/refund?id=" + id+'&imgUrl='+imgUrl)
};
// 售后服务-维修寄回详情
export const repairDetail = (id) => {
  return req("get", "/api/auth/after/service/repair/send/detail?id=" + id)
};
// 售后服务-维修寄回
export const repairDelivery = (params) => {
  return req("post", "/api/auth/after/service/repair/send/delivery",params)
};
// 售后服务-物流列表
export const deliveryList = (params) => {
  return req("post", "/api/auth/after/service/delivery/list",params)
};
// 售后服务-常用物流列表
export const popularDeliveryList = (params) => {
  return req("post", "/api/auth/popular/delivery/list",params)
};
// 售后服务-服务单详情
export const aftersaleDetail = (id) => {
  return req("post", "/api/auth/after/service/detail?id=" + id)
};
// 售后服务-售后地址详情
export const addressDetail = () => {
  return req("get", "/api/auth/after/service/stock/address/detail")
};
// 售后服务-售后地址修改
export const updateAddress = (params) => {
  return req("post", "/api/auth/after/service/stock/address/update",params)
};
// 售后服务-经销商售后管理-列表
export const sellerProductCsList = (params) => {
  return req("post", "/api/auth/product/cs/list",params)
};
// 售后服务-经销商售后管理-新增
export const sellerProductCsAdd = (params) => {
  return req("post", "/api/auth/product/cs/add",params)
};
// 售后服务-经销商售后管理-删除
export const deleteSellerProductCs = (id) => {
  return req("get", "/api/auth/product/cs/delete?id=" + id)
};
// 售后服务-经销商售后管理-修改
export const updateSellerProductCs = (params) => {
  return req("post", "/api/auth/product/cs/update",params)
};
// 售后服务订单列表接口
export const serviceOrderList = (params) => {
  return req("post", "/api/auth/after/service/order/list",params)
};
// 售后服务订单详情列表接口
export const serviceOrderListDetail = (params) => {
  return req("post", "/api/auth/after/service/order/list/detail",params)
};
// 服务单新增
export const serviceAdd = (params) => {
  return req("post", "/api/auth/after/service/add",params)
};
// 快递类型
export const expressType = (comNo) => {
  return req("get", "/api/auth/express/type?comNo=" + comNo)
};
// 商品发货打印机信息
export const printInfo = (params) => {
  return req("get", "/api/auth/order/send/print/info", params)
};

/**
 * 营销管理
 */
// 商品赠品管理-列表
export const giftList = (params) => {
  return req("post", "/api/auth/product/give/list", params)
};
// 商品赠品管理-新增
export const giftAdd = (params) => {
  return req("post", "/api/auth/product/give/add", params)
};
// 商品赠品管理-服务单详情
export const giftDetail = (id) => {
  return req("get", "/api/auth/product/give/detail?id=" + id)
};
// 商品赠品管理-删除
export const deleteGift = (id) => {
  return req("get", "/api/auth/product/give/delete?id=" + id)
};
// 商品赠品管理-修改
export const updateGift = (params) => {
  return req("post", "/api/auth/product/give/update",params)
};
// 商品赠品管理-商品下拉列表
export const productSaleList = (params) => {
  return req("post", "/api/auth/product/sale/list",params)
};
// 优惠券-修改
export const couponUpdate = (params) => {
  return req("post", "/api/auth/voucher/update", params)
};
// 代金券规则-商品分类关联-修改
export const VoucherRulesCategoryUpdate = (params) => {
  return req("post", "/api/auth/voucher/sort/update", params)
};
// 代金券规则-商品分类关联-新增
export const VoucherRulesCategoryAdd = (params) => {
  return req("post", "/api/auth/voucher/sort/add", params)
};
// 优惠券使用规则-修改
export const CouponusagerulesUpdate = (params) => {
  return req("post", "/api/auth/voucher/rule/update", params)
};
// 优惠券使用规则-列表
export const CouponusagerulesList = (params) => {
  return req("post", "/api/auth/voucher/rule/list", params)
};
// 优惠券使用规则-删除
export const CouponusagerulesDelete = (ids) => {
  return req("post", "/api/auth/voucher/rule/delete?ids=" + ids)
};
// 优惠券使用规则-新增
export const CouponusagerulesAdd = (params) => {
  return req("post", "/api/auth/voucher/rule/add", params)
};
// 优惠券-列表
export const couponList = (params) => {
  return req("post", "/api/auth/voucher/list", params)
};
// 优惠券-删除
export const couponDelete = (ids) => {
  return req("post", "/api/auth/voucher/delete?ids=" + ids)
};
// 代金券规则-商品品牌-修改
export const VoucherRulesbrandUpdate = (params) => {
  return req("post", "/api/auth/voucher/brand/update", params)
};
// 代金券规则-商品品牌-新增
export const VoucherRulesbrandAdd = (params) => {
  return req("post", "/api/auth/voucher/brand/add", params)
};
// 优惠券-新增
export const couponAdd = (params) => {
  return req("post", "/api/auth/voucher/add", params)
};
// 优惠券-详情
export const couponDetail = (id) => {
  return req("get", "/api/auth/voucher/detail?id=" + id)
};
// 代金券规则-商品分类关联-详情
export const VoucherRulesCategoryInfo = (voucherRuleId) => {
  return req("get", "/api/auth/voucher/sort/info?voucherRuleId=" + voucherRuleId)
};
// 代金券规则-商品分类关联-删除
export const VoucherRulesCategoryDelete = (id) => {
  return req("get", "/api/auth/voucher/sort/delete?id=" + id)
};
// 代金券使用规则-详情
export const VoucherUseRulesInfo = (id) => {
  return req("get", "/api/auth/voucher/rule/detail?id=" + id)
};
// 订单满减-详情
export const goodFullreductionInfo = (id) => {
  return req("get", "/api/auth/voucher/detail?id" + id)
};
// 代金券规则-商品品牌-详情
export const VoucherRulesbrandInfo = (voucherRuleId) => {
  return req("get", "/api/auth/voucher/brand/info?voucherRuleId=" + voucherRuleId)
};
// 代金券规则-商品品牌-删除
export const VoucherRulesbrandDelete = (id) => {
  return req("get", "/api/auth/voucher/sort/delete?id" + id)
};
// 秒杀专区-列表
export const flashList = (params) => {
  return req("post", "/api/auth/activity/flash/list", params)
};
// 秒杀专区-新增
export const flashAdd = (params) => {
  return req("post", "/api/auth/activity/flash/add", params)
};
// 秒杀专区-修改
export const flashUpdate = (params) => {
  return req("post", "/api/auth/activity/flash/update", params)
};
// 秒杀专区-设置有效
export const flashEnabled = (id) => {
  return req("get", "/api/auth/activity/flash/enabled?id=" + id)
};
// 秒杀专区-删除-无效
export const flashDisable = (id) => {
  return req("get", "/api/auth/activity/flash/disable?id=" + id)
};
// 秒杀专区-详情
export const flashDetail = (id) => {
  return req("get", "/api/auth/activity/flash/detail?id=" + id)
};

// 专属商城管理-列表
export const areaList = (params) => {
  return req("post", "/api/auth/product/activity/area/list", params)
};
// 专属商城管理-新增
export const areaAdd = (params) => {
  return req("post", "/api/auth/product/activity/area/add", params)
};
// 专属商城管理-修改
export const areaUpdate = (params) => {
  return req("post", "/api/auth/product/activity/area/update", params)
};
// 专属商城管理-模版列表
export const areaTemplateList = (params) => {
  return req("post", "/api/auth/product/activity/area/template/list", params)
};
// 专属商城管理-商城二维码
export const areaQrcode = (id) => {
  return req("get", "/api/auth/product/activity/area/qrcode?id=" + id)
};
// 专属商城管理-发布
export const areaPublish = (id) => {
  return req("get", "/api/auth/product/activity/area/publish?id=" + id)
};
// 专属商城管理-商城信息
export const areaInfo = (id) => {
  return req("get", "/api/auth/product/activity/area/info?id=" + id)
};
// 专属商城管理-设置有效
export const areaEnabl = (id) => {
  return req("get", "/api/auth/product/activity/area/enable?id=" + id)
};
// 专属商城管理-设置无效
export const areaDisable = (id) => {
  return req("get", "/api/auth/product/activity/area/disable?id=" + id)
};
// 专属商城管理-详情
export const areaDetail = (id) => {
  return req("get", "/api/auth/product/activity/area/detail?id=" + id)
};

// 专属商城分类管理-列表
export const areaSortList = (params) => {
  return req("post", "/api/auth/product/activity/area/sort/list", params)
};
// 专属商城分类管理-新增
export const areaSortAdd = (params) => {
  return req("post", "/api/auth/product/activity/area/sort/add", params)
};
// 专属商城分类管理-修改
export const areaSortUpdate = (params) => {
  return req("post", "/api/auth/product/activity/area/sort/update", params)
};
// 专属商城分类管理-详情
export const areaSortDetail = (id) => {
  return req("get", "/api/auth/product/activity/area/sort/detail?id=" + id)
};
// 专属商城分类管理-删除
export const areaSortDelete = (id) => {
  return req("get", "/api/auth/product/activity/area/sort/delete?id=" + id)
};

// 专属商城商品-列表
export const itemsList = (params) => {
  return req("post", "/api/auth/product/activity/area/items/list", params)
};
// 专属商城商品-新增
export const itemsAdd = (params) => {
  return req("post", "/api/auth/product/activity/area/items/add", params)
};
// 专属商城商品-修改
export const itemsUpdate = (params) => {
  return req("post", "/api/auth/product/activity/area/items/update", params)
};
// 专属商城商品-选择商品列表
export const itemsProductList = (params) => {
  return req("post", "/api/auth/product/activity/area/items/product/list", params)
};
// 专属商城商品-供应商商品-列表
export const supplyProductList = (params) => {
  return req("post", "/api/auth/agent/product/supply/product/list", params)
};

// 批量导入商城商品
export const itemsBatchImport = (activity_area_id, params) => {
  return req("post", "/api/auth/product/activity/area/items/batch/import?activity_area_id=" + activity_area_id, params)
};
// 批量导入商城商品日志记录
export const batchImportLogsList = (params) => {
  return req("post", "/api/auth/product/activity/area/items/batch/import/logs/list", params)
};
// 批量导入商城商品日志明细
export const batchImportLogsDetailList = (params) => {
  return req("post", "/api/auth/product/activity/area/items/batch/import/logs/detail/list", params)
};
// 批量导入商城商品模板下载
export const batchExport = (params) => {
  return exportExcel("post", "/api/auth/product/activity/area/items/batch/export", params)
};
// 专属商城商品-详情
export const itemsDetail = (id) => {
  return req("get", "/api/auth/product/activity/area/items/detail?id=" + id)
};
// 专属商城商品-删除
export const itemsDelete = (id) => {
  return req("get", "/api/auth/product/activity/area/items/delete?id=" + id)
};


// 专属商城单位管理-列表
export const activityCompanyList = (params) => {
  return req("post", "/api/auth/product/activity/company/list", params)
};
// 专属商城单位管理-新增
export const activityCompanyAdd = (params) => {
  return req("post", "/api/auth/product/activity/company/add", params)
};
// 专属商城单位管理-详情
export const activityCompanyDetail = (id) => {
  return req("get", "/api/auth/product/activity/company/detail?id=" + id)
};
// 专属商城单位管理-删除
export const activityCompanyDelete = (id) => {
  return req("get", "/api/auth/product/activity/company/delete?id=" + id)
};
// 根据松佰单位标准码获取单位
export const custCompany = (standard_code) => {
  return req("post", "/api/auth/cust/company?standard_code=" + standard_code)
};

/**
 * 拼团管理
 */
// 拼团管理-修改
export const groupUpdate = (params) => {
  return req("post", "/api/auth/activity/group/update", params)
};
// 拼团管理-列表
export const groupList = (params) => {
  return req("post", "/api/auth/activity/group/list", params)
};
// 拼团管理-新增
export const groupAdd = (params) => {
  return req("post", "/api/auth/activity/group/add", params)
};
// 拼团管理-设置有效
export const groupEnabled = (id) => {
  return req("get", "/api/auth/activity/group/enabled?id=" + id)
};
// 拼团管理-详情
export const groupDetail = (id) => {
  return req("get", "/api/auth/activity/group/detail?id=" + id)
};
// 拼团管理-删除-设置无效
export const groupDelete = (id) => {
  return req("get", "/api/auth/activity/group/delete?id=" + id)
};
/**
 * 订单满减
 */
// 订单满减-修改
export const discountUpdate = (params) => {
  return req("post", "/api/auth/order/full/discount/update", params)
};
// 订单满减-列表
export const discountList = (params) => {
  return req("post", "/api/auth/order/full/discount/list", params)
};
// 订单满减-新增
export const discountAdd = (params) => {
  return req("post", "/api/auth/order/full/discount/add", params)
};
// 订单满减-设置有效
export const discountEnabled = (id) => {
  return req("get", "/api/auth/order/full/discount/enabled?id=" + id)
};
// 订单满减-删除-设置无效
export const discountDisabled = (id) => {
  return req("get", "/api/auth/order/full/discount/disabled?id=" + id)
};
// 订单满减-详情
export const discountDetail = (id) => {
  return req("get", "/api/auth/order/full/discount/detail?id=" + id)
};
/**
 * 订单满赠
 */
// 订单满赠-修改
export const giveUpdate = (params) => {
  return req("post", "/api/auth/order/full/give/update", params)
};
// 订单满赠-列表
export const giveList = (params) => {
  return req("post", "/api/auth/order/full/give/list", params)
};
// 订单满赠-新增
export const giveAdd = (params) => {
  return req("post", "/api/auth/order/full/give/add", params)
};
// 订单满赠-详情
export const giveDetail = (id) => {
  return req("get", "/api/auth/order/full/give/detail?id=" + id)
};
// 订单满赠-删除
export const giveDelete = (id) => {
  return req("get", "/api/auth/order/full/give/delete?id=" + id)
};
// 订单满赠-设置有效
export const giveEnabled = (id) => {
  return req("get", "/api/auth/order/full/give/enabled?id=" + id)
};
// 订单满赠-设置无效
export const giveDisabled = (id) => {
  return req("get", "/api/auth/order/full/give/disabled?id=" + id)
};
// 订单满赠详情-修改
export const giveDetailUpdate = (params) => {
  return req("post", "/api/auth/order/full/give/item/update", params)
};
// 订单满赠详情-列表
export const giveDetailList = (params) => {
  return req("post", "/api/auth/order/full/give/item/list", params)
};
// 订单满赠详情-详情
export const giveItemDetail = (id) => {
  return req("get", "/api/auth/order/full/give/item/detail?id=" + id)
};
// 订单满赠详情-新增
export const giveDetailAdd = (params) => {
  return req("post", "/api/auth/order/full/give/item/add", params)
};
// 订单满赠详情-删除
export const giveDetailDelete = (id) => {
  return req("get", "/api/auth/order/full/give/item/delete?id=" + id)
};
// 订单满赠详情-设置有效
export const giveDetailEnabled = (id) => {
  return req("get", "/api/auth/order/full/give/item/enabled?id=" + id)
};
// 订单满赠详情-设置无效
export const giveDetailDisabled = (id) => {
  return req("get", "/api/auth/order/full/give/item/disabled?id=" + id)
};
/**
 * 商品议价管理
 **/
// 商品议价管理-列表
export const negoList = (params) => {
  return req("post", "/api/auth/product/nego/list", params)
};
// 商品议价管理-新增
export const negoAdd = (params) => {
  return req("post", "/api/auth/product/nego/add", params)
};
// 商品议价管理-修改
export const negoUpdate = (params) => {
  return req("post", "/api/auth/product/nego/update", params)
};
// 商品议价管理-设置有效
export const negoEnable = (id) => {
  return req("get", "/api/auth/product/nego/enable?id=" + id)
};
// 商品议价管理-设置无效
export const negoDisable = (id) => {
  return req("get", "/api/auth/product/nego/disable?id=" + id)
};
// 商品议价管理-详情
export const negoDetail = (id) => {
  return req("get", "/api/auth/product/nego/detail?id=" + id)
};
// 根据手机号码获取用户id
export const custInfo = (custId) => {
  return req("get", "/api/auth/cust/info?custId=" + custId)
};

/**
 * 财务管理
 **/
// 已开发票-列表
export const invoiceList = (params) => {
  return req("post", "/api/auth/finance/invoice/list", params)
};
// 已开发票-物流信息
export const invoiceDeliveryLog = (deliveryNo,deliveryName) => {
  return req("get", "/api/auth/finance/invoice/delivery/log?deliveryNo=" + deliveryNo +'&deliveryName='+deliveryName)
};
// 发票申请-列表
export const invoiceApplyList = (params) => {
  return req("post", "/api/auth/finance/invoice/apply/list", params)
};
// 发票申请-添加发票
export const addFinanceInvoice = (params) => {
  return req("post", "/api/auth/finance/add/invoice", params)
};
// 发票申请-详情
export const financeDetail = (id) => {
  return req("get", "/api/auth/finance/invoice/detail?id=" + id)
};
// 对账单-列表
export const billRecordList = (params) => {
  return req("post", "/api/auth/finance/bill/record", params)
};
// 对账单-详情
export const billRecordDetail = (id) => {
  return req("get", "/api/auth/finance/bill/record/detail?id=" + id)
};
// 供货对账单-我供货的
export const recordSupply = (params) => {
  return req("post", "/api/auth/finance/agent/bill/record/supply", params)
};
// 供货对账单-给我供货的
export const recordPurchase = (params) => {
  return req("post", "/api/auth/finance/agent/bill/record/purchase", params)
};
// 订单管理-导出
export const billRecordExcel = (params) => {
  return exportExcel("post", "/api/auth/finance/bill/record/export",params)
};
// 销售商发票邮寄地址-详情
export const addressdetail = (id) => {
  return req("get", "/api/auth/seller/invoice/addr/detail?id=" + id)
};
// 销售商发票邮寄地址-列表
export const addressList = (params) => {
  return req("post", "/api/auth/seller/invoice/addr/list", params)
};
// 销售商发票邮寄地址-新增
export const addressAdd = (params) => {
  return req("post", "/api/auth/seller/invoice/addr/add",params)
};
// 销售商发票邮寄地址-修改
export const addressUpdate = (params) => {
  return req("post", "/api/auth/seller/invoice/addr/update",params)
};
// 销售商发票邮寄地址-删除
export const addressDelete = (id) => {
  return req("get", "/api/auth/seller/invoice/addr/delete?id=" + id)
};

// 销售商发票电子邮箱-详情
export const emailDetail = (id) => {
  return req("get", "/api/auth/seller/invoice/email/detail?id=" + id)
};
// 销售商发票电子邮箱-列表
export const emailList = (params) => {
  return req("post", "/api/auth/seller/invoice/email/list",params)
};
// 销售商发票电子邮箱-新增
export const emailAdd = (params) => {
  return req("post", "/api/auth/seller/invoice/email/add",params)
};
// 销售商发票电子邮箱-修改
export const emailUpdate = (params) => {
  return req("post", "/api/auth/seller/invoice/email/update",params)
};
// 销售商发票电子邮箱-删除
export const emailDelete = (id) => {
  return req("get", "/api/auth/seller/invoice/email/delete?id=" + id)
};
// 销售商发票信息（抬头）
export const invoiceTitle = (params) => {
  return req("post", "/api/auth/seller/invoice/title",params)
};
// 销售商服务费开票-申请记录列表
export const applyList = (params) => {
  return req("post", "/api/auth/seller/invoice/apply/list",params)
};
// 销售商服务费开票-申请记录详情
export const applyDetail = (id) => {
  return req("get", "/api/auth/seller/invoice/apply/detail?id=" + id)
};
// 开票金额列表-导出
export const applyExport = (id) => {
  return exportExcel("get", "/api/auth/seller/invoice/apply/record/list/export?id=" + id)
};
// 月账单详情-列表
export const recordDetailList = (params) => {
  return req("post", "/api/auth/seller/invoice/bill/record/detail/list",params)
};
// 月账单详情-列表
export const invoiceRecordList = (params) => {
  return req("post", "/api/auth/seller/invoice/record/list",params)
};
// 销售商服务费开票-申请记录新增
export const invoiceApplyAdd = (params) => {
  return req("post", "/api/auth/seller/invoice/apply/add",params)
};
//月账单详情-导出
export const invoiceBillExport = (id) => {
  return exportExcel("post", "/api/auth/seller/invoice/bill/record/detail/list/export?id=" + id)
};
// 销售商发票邮寄地址-设置默认
export const addrSetDefault = (id) => {
  return req("get", "/api/auth/seller/invoice/addr/set/default?id=" + id)
};
// 销售商发票邮寄地址-设置默认
export const emailSetDefault = (id) => {
  return req("get", "/api/auth/seller/invoice/email/set/default?id=" + id)
};
// 发票申请-发票物流
export const deliveryLog = (deliveryNo) => {
  return req("get", "/api/auth/seller/invoice/delivery/log?deliveryNo=" + deliveryNo)
};

/*
 *订单提现
*/
// 提现
export const billWithdraw = (params) => {
  return req("post", "/api/auth/finance/bill/withdraw",params)
};
// 账单流水
export const billFlow = (params) => {
  return req("post", "/api/auth/finance/bill/flow",params)
};
// 提现记录
export const billWithdrawRecordList = (params) => {
  return req("get", "/api/auth/finance/bill/withdrawRecordList?page=" + params.page + '&rows=' + params.rows + '&startDate=' + params.startDate + '&endDate=' + params.endDate + '&withdrawStatus=' + params.withdrawStatus)
};
// 提现记录明细
// export const billWithdrawDetailList = (params) => {
//   return req("get", "/api/auth/finance/bill/withdrawDetailList?page=" + params.page + '&rows=' + params.rows + '&recordId=' + params.recordId)
// };
// 提现记录明细
export const billWithdrawDetailList = (params) => {
  return req("post", "/api/auth/finance/bill/withdrawDetailList",params)
};
// 提现记录失败明细
export const billWithdrawFailList = (recordId) => {
  return req("get", "/api/auth/finance/bill/withdrawFailList?recordId=" + recordId)
};
// 账单流水-导出
export const billFlowExport = (params) => {
  return exportExcel("post", "/api/auth/finance/bill/flow/export",params)
};
// 提现记录明细-导出
export const billWithdrawDetailExport = (recordId) => {
  return exportExcel("post", "/api/auth/finance/bill/withdrawDetail/export?recordId=" + recordId)
};
// 商户银行信息
export const billBankinfo = (params) => {
  return req("get", "/api/auth/finance/bill/bankinfo")
};
// 设置提现开关
export const billSetManual = (manualValue) => {
  return req("post", "/api/auth/finance/bill/setManual?manualValue=" + manualValue)
};

/*
 * 会员服务管理
 */
// 商品咨询-列表
export const questionList = (params) => {
  return req("post", "/api/auth/product/question/list",params)
};
// 商品咨询-新增
export const questionAdd = (params) => {
  return req("post", "/api/auth/product/question/add",params)
};
// 商品咨询-修改
export const questionUpdate = (params) => {
  return req("post", "/api/auth/product/question/update",params)
};
// 商品咨询-回复
export const questionReply = (params) => {
  return req("post", "/api/auth/product/question/reply",params)
};
// 商品咨询-新增详情
export const questionAddDetail = (params) => {
  return req("post", "/api/auth/product/question/add/detail",params)
};
// 商品咨询-客服列表
export const questionCustList = (params) => {
  return req("post", "/api/auth/product/question/cust/list",params)
};
// 商品咨询-详情
export const questionDetail = (id) => {
  return req("get", "/api/auth/product/question/detail?id=" + id)
};

/*
 * 会员评价管理
 */
// 商品评论-列表
export const discussList = (params) => {
  return req("post", "/api/auth/product/discuss/list",params)
};
// 商品咨询-审核
export const discussApprove = (params) => {
  return req("post", "/api/auth/product/discuss/approve",params)
};
// 商品评论-详情
export const discussDetail = (id) => {
  return req("get", "/api/auth/product/discuss/detail?id=" + id)
};

/*
 * 入驻协议
 */
// 入驻协议
export const sellerAgreement = (params) => {
  return req("post", "/api/auth/seller/agreement",params)
};
/*
 * 系统消息
 */
// 系统消息-列表
export const systemMessageList = (params) => {
  return req("post", "/api/auth/system/message/list",params)
};
// 系统消息-处理
export const systemMessageHand = (params) => {
  return req("post", "/api/auth/system/message/hand",params)
};

// 重新打印电子面单
export const eorderPrint = (params) => {
  return req("post", "/api/auth/eorder/print",params)
};
// 出库单导出
export const listExport = (orderId, recordId, show) => {
  return exportExcel("get", "/api/auth/order/out/list/export?orderId=" + orderId + '&recordId=' + recordId + '&show=' + show)
};







// WEBPACK FOOTER //
// ./src/api/basisMG.js